import React, {Component} from "react";
import { Provider } from "react-redux";
import store from "./store";
import { Router, Route } from "react-router-dom";
import Form from "./components/lalrequestwizard/Wizard";
import history from './history';
import LoginPage from "./components/loginpage/LoginPage";
import ProfileForm from "./components/profileconfig/ProfileFormWrapper";
import Register from './components/register/Register';
import ApplicationDetails from "./components/applicationdetails/ApplicationDetails";
import { DropdownButton, Dropdown, Modal, Button} from 'react-bootstrap';
import AdminDash from "./components/admin/Dashboard";
import IncumbentManagement from "./components/admin/IncumbentManagement";
import UserManagementHomePage from "./components/admin/user/UserManagementPage"

import { securityConstants } from './constants';
import List from "./components/list/List";
import './styles.css';
import { ContactManagement } from "./components/admin/mno/ContactManagement";


export const SERVER_URLS = {
  "api":process.env.REACT_APP_LAL_ENDPOINT,
  "files":"http://localhost:8000"
}



class Routes extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showMnoContactModal: false,
      showOfcomContactModal: false,
      showAboutModal: false
    }
}

  MainRouter = () => (
    <Router history={history}>
      <div className="container">
        <Route component={this.Header} />

        <Route path="/ad/dashboard" component={this.adminDash} />
        <Route path="/ad/stats" component={this.adminIncumbentDataManagement} />
        <Route path="/ad/iam"><UserManagementHomePage/></Route>
        <Route path="/ad/incumbent" component={this.adminIncumbentDataManagement} />
        <Route path="/ad/contact"><ContactManagement/></Route>

        <Route path="/" component={this.Dropdown} />
        <Route exact path="/" component={this.Login} />
        <Route exact path="/sign-up" component={this.SignUp} />

        <Route exact path="/ru/configureprofile" component={this.SetUpProfile} />
        <Route exact path="/ru/list" component={this.Home}/>
        <Route path="/ru/bw" component={this.BencomWizard} />
        <Route path="/ru/details/:requestId" component={this.Details} />
      </div>
    </Router>
  );

  Header = ({location}) => (
    <React.Fragment>
      <a href="https://toolkit.5gnewthinking.org/index.php/Local_Access_License" target="_blank">
        <div className={location.pathname === '/' ? 'jumbo-header' : 'header'}>
            <h1>Local Access Licensing Toolkit</h1>
        </div>
      </a>
    </React.Fragment>
  );


    Dropdown = () => (
      <React.Fragment>
        <Modal show={this.state.showMnoContactModal} onHide={()=>{this.setState({showMnoContactModal: false})}} dialogClassName="modal-90w">
          <Modal.Header closeButton >
              <Modal.Title>MNO Contact Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h2>EE</h2> <a href="mailto:ee@nelsonbostock.com">ee@nelsonbostock.com</a>
            <br/><br/>
            <h2>O2</h2> <a href="mailto:pressoffice@O2.com">pressoffice@O2.com</a>
            <br/><br/>
            <h2>Vodafone</h2> <a href="mailto:brandmarketinguk@vodafone.com">brandmarketinguk@vodafone.com</a><br/><a href="mailto:ukmediarelations@vodafone.com">ukmediarelations@vodafone.com</a>
            <br/><br/>
            <h2>Three UK</h2> <a href="mailto:three@headlandconsultancy.com">three@headlandconsultancy.com</a><br/><a href="mailto:3@itsprettygreen.com">3@itsprettygreen.com</a>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>{this.setState({showMnoContactModal: false})}}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showOfcomContactModal} onHide={() => this.setState({ showOfcomContactModal: false })} dialogClassName="modal-90w">
          <Modal.Header closeButton>
            <Modal.Title>Ofcom Contact Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
            Ofcom,<br />
            Riverside House,<br />
            2a Southwark Bridge Road,<br />
            London,<br />
            SE1 9HA
            </p>
            <p>
            Tel: 020 7981 3000<br />
            Fax: 020 7981 3333
            Website: <a href="https://www.ofcom.org.uk" target="_blank">Ofcom</a> | <a href="https://www.ofcom.org.uk/spectrum" target="_blank">Spectrum</a>
            </p>
            <p>
            Technical enquiries to Shared Spectrum Access Team<br />
            Email: <a href="mailto:sharedspectrumaccess@ofcom.org.uk">sharedspectrumaccess@ofcom.org.uk</a>
            </p>
            <p>
            Licensing enquiries to Spectrum Licensing Team<br />
            Email: <a href="mailto:spectrum.licensing@ofcom.org.uk">spectrum.licensing@ofcom.org.uk</a>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({showOfcomContactModal: false})}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showAboutModal} onHide={()=>{this.setState({showAboutModal: false})}} dialogClassName="about-modal">
          <Modal.Header>
            <h2>About This Toolkit</h2>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <p>
                <span className='rno'>Local Access Licences (LALs)</span> allow organisations to set up rural Cellular Telephone and Fixed Wireless Broadband networks using fallow spectrum belonging to UK <span className='mno'>Mobile Network Operators (MNOs)</span> like EE, Vodafone, O2, and Three. This Toolkit is for expert and non-expert users alike, and helps you to:
                <ul>
                  <li>write and submit your formal LAL application to Ofcom &mdash; <a href='https://www.ofcom.org.uk/__data/assets/pdf_file/0021/158232/local-access-licence-application.pdf' target="_blank">the OfW588 form</a></li>
                  <li>choose where to deploy your transmitters</li>
                  <li>choose which frequencies to use</li>
                  <li>assess the feasibility of your network</li>
                  <li>make contact with the MNO to discuss your plans</li>
                  <li>maximise your chances of a successful application</li>
                </ul>
              </p>

              <p>
                Ofcom will decide whether to grant you a licence based on your answers to questions like:

                <div class="alert alert-primary" role="alert">
                  Will your proposed network cause interference to an MNO's existing network?
                </div>

                The Toolkit performs radio simulations of your network to assess whether your answers are likely to be acceptable to Ofcom:

                <div class="alert alert-success" role="alert">
                  Your proposed network is unlikely to cause interference to an MNO's existing network.
                </div>

                <div class="alert alert-danger" role="alert">
                  Your proposed network will cause interference to an MNO's existing network.
                </div>

                 The detailed results are attached to your application as supporting evidence to improve your chances of a successful application.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div class="button-row">
              <Button variant="secondary" onClick={()=>{this.setState({showAboutModal: false})}}>
                Close
              </Button>
            </div>
          </Modal.Footer>
        </Modal>


        <div>
          <DropdownButton size="lg" id="dropdown-hamburger" title={
            <svg width="1em" height="1em" viewBox="0 0 16 16" className="bi bi-list" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" d="M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
            </svg>
          } onSelect={(e)=> {
            if (e === "mno") {
              this.setState({showMnoContactModal: true})
            } else if (e === "ofcom") {
              this.setState({showOfcomContactModal: true})
            } else if (e === "about") {
              this.setState({showAboutModal:true})
            }
          }}>
            <Dropdown.Item eventKey="about">About</Dropdown.Item>
            <Dropdown.Item href="https://toolkit.5gnewthinking.org/index.php/Local_Access_License" target="_blank">Help</Dropdown.Item>
            {localStorage.getItem("role") === securityConstants.role.RNO && <React.Fragment>
                <Dropdown.Item href="/ru/list">Applications Dashboard</Dropdown.Item>
                <Dropdown.Item href="/ru/configureprofile">User Profile</Dropdown.Item>
                <Dropdown.Item eventKey="mno">MNO Contact Details</Dropdown.Item>
                <Dropdown.Item eventKey="ofcom">Ofcom Contact Details</Dropdown.Item>
                
            </React.Fragment>}
            {localStorage.getItem("role") === securityConstants.role.ADMIN && <React.Fragment>
                <Dropdown.Item href="/ad/dashboard">Admin Dashboard</Dropdown.Item>
                <Dropdown.Item href="/ad/iam">User/Group Management</Dropdown.Item>
                <Dropdown.Item href="/ad/incumbent">Incumbent Data Management</Dropdown.Item>
                <Dropdown.Item href="/ad/stats">Statistics & Audit</Dropdown.Item>
                <Dropdown.Item href="/ad/contact">MNO Contact Details</Dropdown.Item>
            </React.Fragment>}
            <Dropdown.Item href="/">Log out</Dropdown.Item>
          </DropdownButton>
        </div>
      </React.Fragment>
    );  

    Login = () => (
    <div>
        <LoginPage api_url={SERVER_URLS["api"]} LogIn={this.LogIn}/>
    </div>
    );

    adminIncumbentDataManagement = () => (
    <React.Fragment>
        <IncumbentManagement></IncumbentManagement>
    </React.Fragment>
    );

    SetUpProfile = () => (
        <div>
            <ProfileForm api_url={SERVER_URLS["api"]}/>
        </div>
    );


   Home = () => (
    <React.Fragment>
      <h2>Your Local Access Licence (LAL) Applications</h2>
      <List SERVER_URLS={SERVER_URLS} />
    </React.Fragment>
  );

  adminDash = () => (
  <React.Fragment>
      <AdminDash SERVER_URLS={SERVER_URLS}></AdminDash>
  </React.Fragment>
  );

  BencomWizard = ({ location }) => {
    return (
    <div>
      <Form SERVER_URLS={SERVER_URLS}  requestInfo={{request_id: location.state.requestID, pageStates: location.state.page_states, request_state:location.state.request_state}}/>
    </div>
  )};

  SignUp = (props) => (
    <>
      <h2>Sign Up</h2>
      <Register SERVER_URLS={SERVER_URLS} {...props} onSubmitSuccess={() => history.push('/')} />
    </>
  )

  Details = (props) => (
    <>
      <h2>Application Details</h2>
      <ApplicationDetails SERVER_URLS={SERVER_URLS} {...props} />
    </>
  );
  
  render(){
    return(
      
      <Provider store={store}>
      
      <this.MainRouter />
      </Provider>
    );
  }

}



export default Routes
